import { UPDATE_DATA } from "../types";
import { ADD_MASTER_DROPDOWNS, UPDATE_EMPLOYEE_DETAILS } from "./types";

import { getDropdowns as getBuAndTermDropdowns } from "views/pages/manage/masters/studentFinancials/paymentCollection/DownloadReports/constants.js";
import { getUserMgmtFiltersDropdowns } from "views/pages/manage/employeeManagement/userProfile/helper.js";
import { fetchLangAttributeMasterDropdowns } from "views/pages/manage/edpOps/stockManagement/mastersAndMapping/courseMaterialMapping/utilsFunctions";
import { fetchCategCityStateCountryMasterDropdowns } from "views/pages/manage/edpOps/studentDetails/studentInformation/helper";

export const updateData = (object) => {
  return {
    type: UPDATE_DATA,
    payload: object,
  };
};

export const setMasterDropdowns = (dropdowns = {}) => {
  return async (dispatch, getState) => {
    const previousValue = getState().globalData?.masterDropdowns ?? {};

    if (dropdowns) {
      dispatch({
        type: ADD_MASTER_DROPDOWNS,
        masterDropdowns: { ...previousValue, ...dropdowns },
      });
    }
  };
};

export const setBuAndTerm = (cb) => {
  return async (dispatch, getState) => {
    const response = await getBuAndTermDropdowns();
    const previousValue = getState().globalData?.masterDropdowns ?? {};

    if (response) {
      dispatch({
        type: ADD_MASTER_DROPDOWNS,
        masterDropdowns: { ...previousValue, ...response },
      });
      if (cb) cb(response);
    }
  };
};

export const loadUserMgmtFiltersDropdowns = (cb) => {
  return async (dispatch, getState) => {
    const response = await getUserMgmtFiltersDropdowns();
    const previousValue = getState().globalData?.masterDropdowns ?? {};

    if (response) {
      dispatch({
        type: ADD_MASTER_DROPDOWNS,
        masterDropdowns: { ...previousValue, ...response },
      });
      if (cb) cb(response);
    }
  };
};

export const setLangAttributeMasterDropdowns = (callback) => {
  return async (dispatch, getState) => {
    const previousValue = getState().globalData?.masterDropdowns ?? {};
    const response = await fetchLangAttributeMasterDropdowns();

    if (response) {
      dispatch({
        type: ADD_MASTER_DROPDOWNS,
        masterDropdowns: { ...previousValue, ...response },
      });
      if (callback) callback(response);
    }
  };
};

export const setCategoryCityStateDropdowns = (callback) => {
  return async (dispatch, getState) => {
    const previousValue = getState().globalData?.masterDropdowns ?? {};
    const response = await fetchCategCityStateCountryMasterDropdowns();

    if (response) {
      dispatch({
        type: ADD_MASTER_DROPDOWNS,
        masterDropdowns: { ...previousValue, ...response },
      });
      if (callback) callback(response);
    }
  };
};
